/**
 * What the planning run buttons an action bar offers need to start, against the live balance.
 *
 * Read-only and never stored on a button: credit events and billing success refetch it, and pressing the
 * button still re-checks credits on the server.
 */
import { api } from './api';

export interface PlanningStartAction {
  key: string;
  agents?: string[];
  phase?: string;
  /** The base label: a "Retry …" press (Polish More included) is priced as one fix. */
  label?: string;
  /** The bar's prepared task selection, and the press it was prepared for. */
  selection?: { stages: string[]; task_ids: string[] };
  invocation_id?: string;
}

export interface PlanningStartActionQuote {
  required: number;
  shortfall: number;
  /** A design press: pages not planned yet may add sections, so it needs "at least" ``required``. */
  open_ended: boolean;
  /** Worded by the server in the language of the entry's message, only while short. */
  note?: string;
  tooltip?: string;
}

export interface PlanningStartQuote {
  balance: number;
  unlimited: boolean;
  /** The project bills an organization's pool, which only its owner refills. */
  org_pool: boolean;
  upgrade_available: boolean;
  actions: Record<string, PlanningStartActionQuote>;
}

export interface PlanningStartQuoteArgs {
  projectId: string;
  actions: PlanningStartAction[];
  entryId?: string | null;
}

export const planningStartQuoteApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPlanningStartQuote: builder.query<PlanningStartQuote, PlanningStartQuoteArgs>({
      query: ({ projectId, actions, entryId }) => ({
        url: `/api/v1/projects/${projectId}/planning-start-quote`,
        method: 'POST',
        body: { actions, entry_id: entryId ?? null },
      }),
      keepUnusedDataFor: 30,
      providesTags: (_result, _error, { projectId }) => [
        { type: 'PlanningStartQuote' as const, id: projectId },
      ],
    }),
  }),
});

export const { useGetPlanningStartQuoteQuery } = planningStartQuoteApi;
